import { Component, OnInit, inject } from '@angular/core';
import { SlideTogglePadraoComponent } from '../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component';
import { FormFieldComponent } from '../../shared/components/form-field/form-field.component';
import { ButtonPadraoComponent } from '../../shared/components/button-padrao/button-padrao.component';
import { MsgService } from '../../shared/service/msg.service';
import { ParametroAwsSesService } from '../../shared/service/parametro-aws-ses.service';
import { ParametroAwsSesModel } from '../../shared/model/parametros/parametro-aws-ses.model';
import { SelectOneComponent } from '../../shared/components/select-one/select-one.component';

@Component({
  selector: 'app-card-aws-ses',
  standalone: true,
  imports: [
    SlideTogglePadraoComponent,
    FormFieldComponent,
    ButtonPadraoComponent,
    SelectOneComponent
  ],
  templateUrl: './card-aws-ses.component.html',
  styleUrl: './card-aws-ses.component.css'
})
export class CardAwsSesComponent implements OnInit {

  private readonly parametroService = inject(ParametroAwsSesService);
  private readonly msgService = inject(MsgService);

  parametroAwsSes: ParametroAwsSesModel = new ParametroAwsSesModel();
  salvando = false;
  carregando = true;
  readonly opcoesMoeda = [
    { id: 'BRL', nome: 'Real' },
    { id: 'USD', nome: 'Dólar' },
    { id: 'EUR', nome: 'Euro' }
  ];

  ngOnInit() {
    this.buscarParametros();
  }

  buscarParametros() {
    this.parametroService.buscar().subscribe({
      next: (res) => {
        if (res) {
          this.parametroAwsSes = res;
          this.parametroAwsSes.moedaCusto ??= 'USD';
          if(this.parametroAwsSes.ativo == null || this.parametroAwsSes.ativo == undefined){
            this.parametroAwsSes.ativo = true
          }
        }else{
          this.parametroAwsSes.ativo = true
          this.parametroAwsSes.moedaCusto = 'USD';
        }
        this.carregando = false;
      },
      error: () => {
        this.carregando = false;
        this.msgService.msgErro('Erro ao buscar as configurações de envio');
      }
    });
  }

  converterEAtribuirLimiteMsg(valor: any) {
    this.parametroAwsSes.limiteMsg = valor ? Number(valor) : undefined;
  }

  converterEAtribuirLimiteMinuto(valor: any) {
    this.parametroAwsSes.limiteMsgsMinutos = valor ? Number(valor) : undefined;
  }

  converterEAtribuirValorUnitario(valor: any) {
    this.parametroAwsSes.valorUnitarioMsg = this.converterValorMonetario(valor);
  }

  selecionarMoeda(opcao?: { id: string }): void {
    if (opcao) this.parametroAwsSes.moedaCusto = opcao.id as 'BRL' | 'USD' | 'EUR';
  }

  obterMoeda() {
    return this.opcoesMoeda.find(opcao => opcao.id === this.parametroAwsSes.moedaCusto);
  }

  obterSimboloMoeda(): string {
    return this.parametroAwsSes.moedaCusto === 'BRL'
      ? 'R$'
      : this.parametroAwsSes.moedaCusto === 'EUR' ? '€' : 'US$';
  }

  private converterValorMonetario(valor: unknown): number | undefined {
    if (valor === '' || valor == null) return undefined;
    const numero = typeof valor === 'number'
      ? valor
      : Number(String(valor).replace(/[^\d.-]/g, ''));
    return Number.isFinite(numero) ? numero : undefined;
  }

  salvar() {
    if (!this.validarCampos()) {
      return;
    }
    if (this.salvando) {
      return;
    }
    this.salvando = true;
    this.parametroService.salvar(this.parametroAwsSes).subscribe({
      next: () => {
        this.msgService.msgSucesso('Configurações de envio salvas com sucesso');
        this.buscarParametros();
      },
      error: (err) => {
        this.msgService.msgErro(err?.error?.message ?? 'Erro ao salvar as configurações de envio');
      },
      complete: () => this.salvando = false
    });
  }

  validarCampos(): boolean {
    if (!this.parametroAwsSes.accessKeyId || this.parametroAwsSes.accessKeyId.trim() === '') {
      this.msgService.msgAdvertencia('Preencha o campo Access Key ID');
      return false;
    }
    if (!this.parametroAwsSes.secretAccessKey || this.parametroAwsSes.secretAccessKey.trim() === '') {
      this.msgService.msgAdvertencia('Preencha o campo Secret Access Key');
      return false;
    }
    if (!this.parametroAwsSes.region || this.parametroAwsSes.region.trim() === '') {
      this.msgService.msgAdvertencia('Preencha o campo Region');
      return false;
    }
    if (!this.parametroAwsSes.emailRemetente || this.parametroAwsSes.emailRemetente.trim() === '') {
      this.msgService.msgAdvertencia('Preencha o campo E-mail de Envio');
      return false;
    }
    if (!this.parametroAwsSes.limiteMsg || this.parametroAwsSes.limiteMsg <= 0) {
      this.msgService.msgAdvertencia('Preencha um Limite de Mensagens maior que zero');
      return false;
    }
    if (!this.parametroAwsSes.limiteMsgsMinutos || this.parametroAwsSes.limiteMsgsMinutos <= 0) {
      this.msgService.msgAdvertencia('Preencha um Tempo em minutos maior que zero');
      return false;
    }
    if (this.parametroAwsSes.valorUnitarioMsg == null || this.parametroAwsSes.valorUnitarioMsg < 0) {
      this.msgService.msgAdvertencia('Preencha um Valor Unitário msg maior ou igual a zero');
      return false;
    }
    if (!this.parametroAwsSes.moedaCusto) {
      this.msgService.msgAdvertencia('Selecione a moeda do valor unitário');
      return false;
    }
    if (!this.parametroAwsSes.usuario || this.parametroAwsSes.usuario.trim() === '') {
      this.msgService.msgAdvertencia('Preencha o Usuário de acesso à API AWS SES');
      return false;
    }
    if (!this.parametroAwsSes.senha || this.parametroAwsSes.senha.trim() === '') {
      this.msgService.msgAdvertencia('Preencha a Senha de acesso à API AWS SES');
      return false;
    }
    return true;
  }
}
